"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItemStatus = exports.ShopifyChargeItemType = exports.InvoiceItemType = exports.InvoiceItemPrefix = exports.InvoiceState = void 0;
var InvoiceState;
(function (InvoiceState) {
    InvoiceState["CREATED"] = "CREATED";
    InvoiceState["INVOICED"] = "INVOICED";
    InvoiceState["PENDING"] = "PENDING";
    InvoiceState["DELETED"] = "DELETED";
    InvoiceState["ERROR"] = "ERROR";
    InvoiceState["NO_ACCOUNT"] = "NO_ACCOUNT";
    InvoiceState["MISSED_BILLING_WINDOW"] = "MISSED_BILLING_WINDOW";
    InvoiceState["CREDITED"] = "CREDITED";
})(InvoiceState || (exports.InvoiceState = InvoiceState = {}));
var InvoiceItemPrefix;
(function (InvoiceItemPrefix) {
    InvoiceItemPrefix["INBOUND_SHIPMENT_ITEM_PREFIX"] = "ShipmentID";
    InvoiceItemPrefix["ORDER_ITEM_PREFIX"] = "OrderID";
    InvoiceItemPrefix["STORAGE_ITEM_PREFIX"] = "Storage SKU";
    InvoiceItemPrefix["INBOUND_LABEL_ITEM_PREFIX"] = "TrackingID";
    InvoiceItemPrefix["CREDIT"] = "Credit";
})(InvoiceItemPrefix || (exports.InvoiceItemPrefix = InvoiceItemPrefix = {}));
var InvoiceItemType;
(function (InvoiceItemType) {
    InvoiceItemType["FULFILLMENT"] = "Fulfillment Fees";
    InvoiceItemType["INTERNATIONAL_FULFILLMENT"] = "International Fulfillment Fees";
    InvoiceItemType["STORAGE"] = "Storage Fees - Standard";
    InvoiceItemType["STORAGE_365_DAYS_PLUS"] = "Storage Fees - Units 365 and Over Days Old";
    InvoiceItemType["STORAGE_LATE"] = "Late Storage Fees";
    InvoiceItemType["INBOUND_SHIPPING"] = "Inbound Carrier Shipping Costs";
    InvoiceItemType["CREDIT"] = "CREDIT";
    InvoiceItemType["DECREMENT_CREDIT"] = "DECREMENT_CREDIT";
    InvoiceItemType["DELIVERR_FREIGHT"] = "DELIVERR_FREIGHT";
    InvoiceItemType["REMOVAL"] = "Removal Fees";
    InvoiceItemType["CROSSDOCK_COST"] = "Forwarding Fees";
    InvoiceItemType["DEPRECATED_CROSSDOCK_COST"] = "Crossdock Costs";
    InvoiceItemType["DEPRECATED_FULFILLMENT"] = "FULFILLMENT";
    InvoiceItemType["DEPRECATED_INBOUND_SHIPPING"] = "INBOUND_SHIPPING";
    InvoiceItemType["DEPRECATED_STORAGE"] = "STORAGE";
    InvoiceItemType["PENDING_CREDIT"] = "Pending Credit";
    InvoiceItemType["FLEXPORT_FREIGHT"] = "FLEXPORT_FREIGHT";
    InvoiceItemType["CREDIT_CARD_PROCESSING_FEE"] = "CREDIT_CARD_PROCESSING_FEE";
    InvoiceItemType["PAYPAL_PROCESSING_FEE"] = "PAYPAL_PROCESSING_FEE";
})(InvoiceItemType || (exports.InvoiceItemType = InvoiceItemType = {}));
var ShopifyChargeItemType;
(function (ShopifyChargeItemType) {
    ShopifyChargeItemType["RETURNS_INSPECTION_FEE"] = "RETURNS_INSPECTION_FEE";
    ShopifyChargeItemType["RETURNS_SHIPPING_FEE"] = "RETURNS_SHIPPING_FEE";
    ShopifyChargeItemType["NC_BARCODE"] = "NC_BARCODE";
    ShopifyChargeItemType["NC_SHIPPINGPLAN"] = "NC_SHIPPINGPLAN";
    ShopifyChargeItemType["NC_LABEL"] = "NC_LABEL";
    ShopifyChargeItemType["NC_PREPLABEL"] = "NC_PREPLABEL";
    ShopifyChargeItemType["RS_BOL_FEE"] = "RS_BOL_FEE";
    ShopifyChargeItemType["RS_CARTON_HANDLING_FEE"] = "RS_CARTON_HANDLING_FEE";
    ShopifyChargeItemType["RS_FTL_PROCESSING_FEE"] = "RS_FTL_PROCESSING_FEE";
    ShopifyChargeItemType["RS_GRADE_B_PALLET_FEE"] = "RS_GRADE_B_PALLET_FEE";
    ShopifyChargeItemType["RS_INBOUND_FEE"] = "RS_INBOUND_FEE";
    ShopifyChargeItemType["RS_INBOUND_FLOOR_LOADED_20_FEE"] = "RS_INBOUND_FLOOR_LOADED_20_FEE";
    ShopifyChargeItemType["RS_INBOUND_FLOOR_LOADED_40_FEE"] = "RS_INBOUND_FLOOR_LOADED_40_FEE";
    ShopifyChargeItemType["RS_INBOUND_PALLETIZED_FEE"] = "RS_INBOUND_PALLETIZED_FEE";
    ShopifyChargeItemType["RS_LABEL_FEE"] = "RS_LABEL_FEE";
    ShopifyChargeItemType["RS_LTL_PROCESSING_FEE"] = "RS_LTL_PROCESSING_FEE";
    ShopifyChargeItemType["RS_OUTBOUND_FEE"] = "RS_OUTBOUND_FEE";
    ShopifyChargeItemType["RS_PALLET_HANDLING_FEE"] = "RS_PALLET_HANDLING_FEE";
    ShopifyChargeItemType["RS_PARCEL_PROCESSING_FEE"] = "RS_PARCEL_PROCESSING_FEE";
    ShopifyChargeItemType["RS_RECEIPT_STORAGE_FEE"] = "RS_RECEIPT_STORAGE_FEE";
    ShopifyChargeItemType["RS_STORAGE_FEE"] = "RS_STORAGE_FEE";
    ShopifyChargeItemType["RS_STRETCH_WRAP_FEE"] = "RS_STRETCH_WRAP_FEE";
    ShopifyChargeItemType["SPECIAL_PROJECT"] = "SPECIAL_PROJECT";
    ShopifyChargeItemType["FREIGHT"] = "FREIGHT";
    ShopifyChargeItemType["PARCEL"] = "PARCEL";
    ShopifyChargeItemType["PREP_BUBBLE_WRAPPING"] = "PREP_BUBBLE_WRAPPING";
    ShopifyChargeItemType["PREP_SKU_LABELS"] = "PREP_SKU_LABELS";
    ShopifyChargeItemType["PREP_BOX_CONTENT_LABELS"] = "PREP_BOX_CONTENT_LABELS";
    ShopifyChargeItemType["PREP_BAGGING"] = "PREP_BAGGING";
    ShopifyChargeItemType["PREP_BOX_BUILDING"] = "PREP_BOX_BUILDING";
    ShopifyChargeItemType["PREP_FLOOR_LOADED_CONTAINER"] = "PREP_FLOOR_LOADED_CONTAINER";
    ShopifyChargeItemType["PREP_KITTING"] = "PREP_KITTING";
    ShopifyChargeItemType["PREP_QUALITY_CHECK"] = "PREP_QUALITY_CHECK";
    ShopifyChargeItemType["PREP_BARCODE_TRANSLATION"] = "PREP_BARCODE_TRANSLATION";
    ShopifyChargeItemType["PREP_CUSTOM_SKU_LABEL"] = "PREP_CUSTOM_SKU_LABEL";
    ShopifyChargeItemType["PREP_BUBBLE_MAILER"] = "PREP_BUBBLE_MAILER";
    ShopifyChargeItemType["PREP_CARTON_LABEL"] = "PREP_CARTON_LABEL";
    ShopifyChargeItemType["PREP_PALLET_LABEL"] = "PREP_PALLET_LABEL";
    ShopifyChargeItemType["PREP_BAGGING_PROTECTION"] = "PREP_BAGGING_PROTECTION";
    ShopifyChargeItemType["PREP_DAMAGE_PROTECTION"] = "PREP_DAMAGE_PROTECTION";
    ShopifyChargeItemType["PREP_OTHER"] = "PREP_OTHER";
})(ShopifyChargeItemType || (exports.ShopifyChargeItemType = ShopifyChargeItemType = {}));
var InvoiceItemStatus;
(function (InvoiceItemStatus) {
    InvoiceItemStatus["CREATED"] = "CREATED";
    InvoiceItemStatus["PENDING"] = "PENDING";
    InvoiceItemStatus["INVOICED"] = "INVOICED";
    InvoiceItemStatus["ERROR"] = "ERROR";
    InvoiceItemStatus["NO_ACCOUNT"] = "NO_ACCOUNT";
})(InvoiceItemStatus || (exports.InvoiceItemStatus = InvoiceItemStatus = {}));
//# sourceMappingURL=InvoiceItem.js.map